import { render, staticRenderFns } from "./V2ProductDetailModal.vue?vue&type=template&id=4fb90ae2&"
import script from "./V2ProductDetailModal.vue?vue&type=script&lang=js&"
export * from "./V2ProductDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports